<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Events } from "./components/modeldemo/Events.js";
import { isWeixin } from "../src/components/modeldemo/Device/Browser.js";
import { mapState, mapActions } from "vuex";
import {
  appidP,
  appidD,
  redirect_uri,
} from "../src/views/Website/WXconfig.json";
import { wexinShare } from "../src/utils/wxShare.js";
import { handleLocalStorage } from "../src/utils/handleLocalStorage.js";
import Communication from "../src/utils/communication.js";

let appidValue = process.env.NODE_ENV === "production" ? appidP : appidD;
let urlValue =
  process.env.NODE_ENV === "production"
    ? "https://cy.idea888.com/admin"
    : "https://test.idea888.com/admin";
export default {
  name: "App",
  data() {
    return {
      isInWeixin: false,
      shareLinkDetail: "",
      shareLinkTitle: "",
      pictureUrl: "",
    };
  },
  mounted() {
    console.log('start.....');
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
    this.isInWeixin = !!isWeixin();
    this.oldopenid = this.getQueryString("openid11");
    this.keyDown();
  },
  watch: {
    $route(to, from) {
      if (this.isInWeixin) {
        if (to.path !== "/" || from.path !== "/") {
          // this.getSignatureFuc(this.oldopenid);
          this.handleWX();
        } else {
          this.handleWX();
        }
      }
    },
  },
  methods: {
    ...mapActions("user", ["updatedInfo"]),
    getShareInfo() {
      let _name = this.$route.name;
      let _linkInfo = handleLocalStorage.getSomeItem("linkData");
      if (_linkInfo) {
        this.shareLinkTitle =
          _name == "OuterChain"
            ? _linkInfo.modelName
            : "川云引擎 ｜ VR云展馆平台";
        this.shareLinkDetail =
          _name == "OuterChain" ? _linkInfo.remarks : "3D场景渲染专家";
        this.pictureUrl =
          _name == "OuterChain"
            ? _linkInfo.pictureUrl
            : "https://cy.idea888.com/data/public/logo.jpg";
      } else {
        this.shareLinkTitle = "川云引擎 ｜ VR云展馆平台";
        this.shareLinkDetail = "3D场景渲染专家";
        this.pictureUrl = "https://cy.idea888.com/data/public/logo.jpg";
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    setPropsFuc(url) {
      let obj = {};
      if (url.split("?")[1]) {
        let str = url.split("?")[1].split("&");
        for (var i = 0; i < str.length; i++) {
          let a = str[i].split("=");
          obj[a[0]] = a[1];
        }
      }
      return obj;
    },
    getInfoEvent(id) {
      if (!id || id == "") return;
      this.$http("/api/sys/centerCheckPhone", { accountUuId: id }).then(
        (res) => {
          handleLocalStorage.setTokenItem(res.data.data.token);
          handleLocalStorage.setSomeItem(
            "refreshToken",
            res.data.data.refreshToken
          );
          handleLocalStorage.setSomeItem("userInfo", res.data.data);
          handleLocalStorage.setSomeItem("dcAccountUuid", id);
          this.updatedInfo(res.data.data);
        }
      );
    },
    handleWX() {
      let _propsData = this.setPropsFuc(location.href);
      if (
        _propsData.dc_account_uuid ||
        handleLocalStorage.getSomeItem("isShareConfig")
      ) {
        this.getInfoEvent(_propsData.dc_account_uuid);
        handleLocalStorage.setSomeItem("isShareConfig", true);
        let _linkSrc = handleLocalStorage.getSomeItem("linkSrc");
        this.getShareInfo();
        let data = {
          title: this.shareLinkTitle, // 分享标题
          desc: this.shareLinkDetail,
          link: this.$route.name == 'OuterChain' ? _linkSrc : location.href,
          imgUrl: this.pictureUrl, // 分享图标
        };
        wexinShare({}, data);
        return;
      }
      // 判断当前是否为微信浏览器
      if (this.isInWeixin) {
        if (_propsData.cxlweauth && _propsData.cxlweauth == 1) {
          return;
        }
        //判断用户是否进入过授权页
        if (!JSON.parse(handleLocalStorage.getSomeItem("wxIsAuthorized"))) {
          //若未进入过授权页,打上进入过授权页的标记,并跳转至授权页
          handleLocalStorage.setSomeItem("wxIsAuthorized", true);
          const redirectUri = encodeURIComponent(location.href);
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appidValue}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state#wechat_redirect`;
          // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri+'%3fid%3d'+this.$route.query.id}&response_type=code&scope=snsapi_userinfo&state#wechat_redirect`
        } else {
          //若进入过授权页
          //判断url是否携带code,若有,授权成功,用code向后端请求微信用户数据
          let propsData = this.setPropsFuc(location.href);

          if (propsData.urlData) {
            let _data = this.dataFuc(decodeURIComponent(propsData.urlData));
            handleLocalStorage.setSomeItem("linkData", _data);
          }
          if (propsData.code) {
            //确认授权
            const code = Array.isArray(propsData.code)
              ? propsData.code[propsData.code.length - 1]
              : propsData.code;
            let _wxInfo = handleLocalStorage.getSomeItem("wxUserInfo");
            if (_wxInfo) {
              this.getSignatureFuc(JSON.parse(_wxInfo).openid);
              Communication.$emit("OnMessage", _wxInfo);
              return;
            }
            this.$http("/api/wechat/getUserInfo", {
              code,
            })
              .then((res) => {
                return new Promise((resolve, reject) => {
                  if (res.data.status === 200) {
                    const wxUserInfo = JSON.parse(res.data.data);
                    if (!wxUserInfo.openid) {
                      this.$Message.error("获取微信授权异常");
                      return;
                    }
                    handleLocalStorage.setSomeItem("wxUserInfo", res.data.data);
                    Communication.$emit("OnMessage", res.data.data);
                    this.getSignatureFuc(wxUserInfo.openid);

                    // window.sessionStorage.setItem('wxUserInfo', res.data.data)
                  } else {
                    this.$Message.error("获取微信授权失败");
                    reject();
                  }
                });
              })
              .catch(() => {
                this.$Message.error("获取微信授权异常");
              })
              .then((avatarImg) => {
                return new Promise((resolve, reject) => {
                  const cvs = document.createElement("canvas");
                  const ctx = cvs.getContext("2d");
                  cvs.width = avatarImg.width;
                  cvs.height = avatarImg.height;
                  ctx.drawImage(avatarImg, 0, 0, cvs.width, cvs.height);
                  cvs.toBlob(
                    (blob) => {
                      const wxUserId = JSON.parse(
                        window.sessionStorage.getItem("wxUserInfo")
                      ).openid;
                      const imgFile = new File([blob], `${wxUserId}.jpg`, {
                        type: blob.type,
                      });
                      const fileData = {
                        file: imgFile,
                        type: "wechat_avatar",
                        modelId: this.$route.query.id,
                      };
                      resolve(fileData);
                    },
                    "image/jpeg",
                    1
                  );
                });
              })
              .catch(() => {
                this.$Message.error("用户头像加载异常");
              })
              .then((res) => {
                if (res.data.status === 200) {
                  const wxUserInfo = JSON.parse(
                    window.sessionStorage.getItem("wxUserInfo")
                  );
                  wxUserInfo.headimgurlBE = res.data.data.fileUrl;
                  wxUserInfo.avatarInBE = true;
                  window.sessionStorage.setItem(
                    "wxUserInfo",
                    JSON.stringify(wxUserInfo)
                  );
                } else {
                  this.$Message.error("微信用户头像读取异常");
                }
              })
              .catch(() => {
                this.$Message.error("微信用户头像读取异常");
              });
          } else {
            let _wxInfo = handleLocalStorage.getSomeItem("wxUserInfo");
            if (_wxInfo) {
              this.getSignatureFuc(JSON.parse(_wxInfo).openid);
              return;
            }
            //无code,用户拒绝授权,不做操作
          }
        }
      } else {
        //非微信浏览器,不做操作
      }
    },
    //处理数据
    dataFuc(data) {
      let a = data.split("&");
      let link = a[1].split("=")[1];
      let name = a[2].split("=")[1];
      let remarks = a[3].split("=")[1];
      let obj = {
        externalModelLink: link,
        modelName: name,
        remarks: remarks,
      };
      return obj;
    },
    getSignatureFuc(openid) {
      let url = location.href;
      this.getShareInfo();
      this.$http("/api/wechat/getSignature", { currentUrl: url }).then(
        (res) => {
          if (res.data.status !== 200) {
            return this.$Message.error(res.data.msg);
          }
          let wxUserInfo = res.data.data;
          let obj = {
            appId: wxUserInfo.appId,
            nonceStr: wxUserInfo.nonceStr,
            signature: wxUserInfo.signature,
            timestamp: wxUserInfo.timestamp.toString(),
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          };
          let _url = JSON.parse(JSON.stringify(url.split("?")[0]));
          // let _linkSrc = encodeURIComponent(handleLocalStorage.getSomeItem('linkSrc'));
          let _linkInfo = handleLocalStorage.getSomeItem("linkData");
          let _linkSrc = handleLocalStorage.getSomeItem("linkSrc");
          let url_result;
          if (_linkSrc) {
            let name = _linkInfo.modelName;
            let _remarks = _linkInfo.remarks;
            let urlData = encodeURIComponent(
              "&linkSrc=" +
              _linkSrc +
              "&modelName=" +
              name +
              "&remarks=" +
              _remarks
            );
            url_result = openid
              ? _url + "?openid11=" + openid + "&urlData=" + urlData
              : _url + "?urlData=" + urlData;
          } else {
            url_result = openid ? _url + "?openid11=" + openid + `&id=${this.getQueryString('id')}` : _url;
          }
          let shareData = {
            title: this.shareLinkTitle, // 分享标题
            desc: this.shareLinkDetail,
            link: url_result,
            // link: 'https://cy.idea888.com/admin' + '?openid11=' + openid,
            imgUrl: this.pictureUrl, // 分享图标
          };
          wexinShare(obj, shareData);
        }
      );
      if (this.oldopenid) {
        this.getSave(openid);
      }
    },
    getSave(newOpenId) {
      // 终端类型（1:PC，2：手机）
      let terminalType = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      )
        ? 2
        : 1;
      let data = {
        sourceOpenId: this.oldopenid,
        targetOpenId: newOpenId,
        type: 1,
        terminalType: terminalType,
      };
      this.$http("/api/shareClues/save", data, "POST").then((res) => {
        if (res.data.status !== 200) {
          return this.$Message.error(res.data.msg);
        }
      });
    },
    keyDown() {
      document.onkeydown = (e) => {
        console.log(location.href, "路径");
        parent.postMessage({ type: Events.Keyboard, msg: { key: e.key } }, "*");
      };
    },
  },
};
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

:root body {
  position: absolute;
}

body {
  width: 100vw;
  overflow: hidden;
}
</style>
